module.exports = __webpack_public_path__ + "bd0bd7bf98c9cae80269d418422fb63c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/giant-bow-red.png
// module id = 2207
// module chunks = 0